module.exports = __webpack_public_path__ + "img/360-utomhus-entre.72148419.jpg";